import jwtDecode from 'jwt-decode';
import Cookies from 'universal-cookie';
import axios from 'axios';

const cookies = new Cookies();

export const saveToken = (token) => {
    cookies.set('p7vendas-token', token);
}

export const getToken = () => {
    return cookies.get('p7vendas-token');
}

export const removeToken = () => {
    let lista = cookies.get('p7vendas-listapermissoes');
    if (lista) {
        lista = lista.split(";");
        for (var x in lista) {
            cookies.remove('p7vendas-permissoes-' + lista[x]);
        };
    }
    cookies.remove('p7vendas-listapermissoes');
    cookies.remove('p7vendas-parametros');
    return cookies.remove('p7vendas-token');
}

export const isLoggedIn = () => {
    return !!getToken();
}

export const getUsuario = () => {
    // return jwtDecode(getToken()).usuario; 

    const jsonValue = cookies.get('p7vendas-parametros')
    return jsonValue;
}

export const getUsuarioToken = () => {
    return jwtDecode(getToken()).usuario; 
}

export const getPermissoes = () => {
    return jwtDecode(getToken()).permissoes || [];
}

export const getTipoUsuario = async () => {
    return jwtDecode(getToken()).usuario.usu_tipo;
}

export const getEmpresa = async () => {
    return jwtDecode(getToken()).usuario.emp_codigo;
}

export const saveParametros = () => {
    // console.log('saveParametros');
    const usuario = jwtDecode(getToken()).usuario.usu_cpf;
    axios.get('/usuarios/parametrosUsuario', {
        params: {
            usuario
        }
    }).then(response => {
        // console.log('saveParametros: ', JSON.stringify(response.data));
        cookies.set('p7vendas-parametros', JSON.stringify(response.data));
    }).catch(error => {
        console.error(error.response);
    })
}

export const savePermissoes = (grupo) => {
    // console.log('savePermissoes: ', grupo);

    const tipoUsuario = jwtDecode(getToken()).usuario.usu_tipo;
    if (tipoUsuario) {
        axios.get('/usuarios/listaPermissoes', {
            params: {
                grupo
            }
        }).then(response => {
            // console.log('savePermissoes: ', response.data);

            const { data } = response;
            const listaPermissoes = response.data;

            let lista = '';
            for (var x in listaPermissoes) {
                lista = lista + listaPermissoes[x].pp_page + ';';
                cookies.set('p7vendas-permissoes-' + listaPermissoes[x].pp_page, String(listaPermissoes[x].pg_consultar) + String(listaPermissoes[x].pg_novo) + String(listaPermissoes[x].pg_editar) + String(listaPermissoes[x].pg_excluir));
            };
            cookies.set('p7vendas-listapermissoes', lista);
        }).catch(error => {
            console.error(error.response);
        })
    }
}

export const getTemPermissao = (page, perm) => {
    const tipoUsuario = jwtDecode(getToken()).usuario.usu_tipo;
    // console.log('page: ', page);
    // console.log('tipoUsuario: ', tipoUsuario);
    // console.log('perm: ', perm);

    const permissoes = cookies.get('p7vendas-permissoes-' + page);
    // console.log('getTemPermissao DESC: ', permissoes);

    if (tipoUsuario) {
        if (permissoes) {
            if (String(perm) === 'cons') {
                // console.log('getTemPermissao CONS: ', String(permissoes).substring(0,1) === '1' ? true : false);
                return String(permissoes).substring(0, 1) === '1' ? true : false;
            }
            if (String(perm) === 'novo') {
                // console.log('getTemPermissao NOVO: ', String(permissoes).substring(1,2) === '1' ? true : false);
                return String(permissoes).substring(1, 2) === '1' ? true : false;
            }
            if (String(perm) === 'editar') {
                // console.log('getTemPermissao EDITAR: ', String(permissoes).substring(2,3) === '1' ? true : false);
                return String(permissoes).substring(2, 3) === '1' ? true : false;
            }
            if (String(perm) === 'excluir') {
                // console.log('getTemPermissao EXCLUIR: ', String(permissoes).substring(3,4) === '1' ? true : false);
                return String(permissoes).substring(3, 4) === '1' ? true : false;
            }
        }
    } else {
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/utils/LoginManager.js